<template>
  <div>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-account-multiple
          </v-icon>
          Adminユーザ
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="userName"
                        clearable
                        persistent-placeholder
                        label="氏名"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="userRole"
                        :items="userRoles"
                        clearable
                        label="ロール"
                        persistent-placeholder
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                    &nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->

    <v-row>
      <v-col class="text-left">
        <h4>
          {{ total_count }} 件
        </h4>
      </v-col>
      <v-col class="text-right">
        <v-btn
          color="info"
          @click="addButtonClickEvent"
        >
          <v-icon>mdi-plus</v-icon>&nbsp;ユーザの追加
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="rounded-card">
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="users"
              :items-per-page="-1"
              disable-pagination
              disable-sort
              hide-default-footer
            >
              <template v-slot:[`item.name`]="{ item }">
                <span :title="item.name">{{ item.name | truncate(15) }}</span>
              </template>
              <template v-slot:[`item.login_id`]="{ item }">
                <span :title="item.login_id">{{ item.login_id | truncate(15) }}</span>
              </template>
              <template v-slot:[`item.email`]="{ item }">
                <span :title="item.email">{{ item.email | truncate }}</span>
              </template>
              <template v-slot:[`item.role`]="{ item }">
                {{ item.role | admin_user_role }}
              </template>
              <template v-slot:[`item.last_login_at`]="{ item }">
                {{ item.last_login_at | unix_datetime_format }}
              </template>
              <template v-slot:[`item.editable`]="{item}">
                <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  icon
                  color="info darken-2"
                  @click="showButtonClickEvent(item)"
                >
                  <v-icon>mdi-file-document-outline</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="info"
                  @click="showButtonClickEvent(item)"
                >
                  参照する
                </v-btn>
                <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  color="info darken-2"
                  icon
                  @click="editButtonClickEvent(item)"
                >
                  <v-icon>mdi-note-edit</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="info"
                  @click="editButtonClickEvent(item)"
                >
                  編集する
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row
      v-if="hasResult"
      dense
    >
      <v-col>
        <v-pagination
          v-model="page"
          :length="pagination.total_pages"
          :total-visible="totalVisible"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="changePage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
export default {
  name: 'UserIndex',
  components: {},
  mixins: [],
  data () {
    return {
      page: 1,
      totalVisible: 7,
      total_count: null,
      userName: null,
      userRole: null,
      withDeleted: false,
      userRoles: [
        { value: 'admin', text: '管理者' },
        { value: 'editor', text: '一般' },
      ],
      tableHeaders: [
        { text: '氏名', value: 'name' },
        { text: 'ログインID', value: 'login_id' },
        { text: 'ロール', value: 'role' },
        { text: 'メールアドレス', value: 'email' },
        { text: '最終ログイン日時', value: 'last_login_at' },
        { text: '', value: 'editable', align: 'end' },
      ],
      users: []
    }
  },
  computed: {
    ...mapState('AdminUser', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapGetters('AdminUser', [
      'hasResult'
    ]),
  },
  watch: {
    userName (newVal) {
      this.saveCondition({ name: newVal })
    },
    userRole (newVal) {
      this.saveCondition({ role: newVal })
    },
  },
  created() {

    if (this.$route.params.resetCondition) {
      this.resetCondition()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }

    this.userName = this.searchCondition.name
    this.userRole = this.searchCondition.role
    this.page = this.pagination.current_page
    this.searchUser()
  },
  methods: {
    ...mapActions('AdminUser', {
      fetchUsers: 'index',
      saveCondition: 'saveCondition',
      resetCondition: 'resetState',
      resetPagination: 'resetPagination',
    }),
    addButtonClickEvent () {
      this.$router.push({name: 'AdminUserNew'})
    },
    showButtonClickEvent (item) {
      this.$router.push({name: 'AdminUser', params: { id: item.id }})
    },
    editButtonClickEvent (item) {
      this.$router.push({name: 'AdminUserEdit', params: { id: item.id }})
    },
    searchButtonClickEvent () {
      this.page = 1
      this.searchUser()
    },
    changePage () {
      this.searchUser()
    },
    searchUser () {
      let params = {
        name: this.userName,
        role: this.userRole,
        page: this.page
      }
      this.fetchUsers(params).then((content) => {
        this.users = content.administrators
        this.total_count = content.pagination.total_count
      })
    },
  }
}
</script>

<style scoped lang="scss">
.panel-header-color {
  color: #0D74BA !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;
      &::before {
        color: #0D74BA !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #DCE7EB;
}

</style>
